export default __webpack_public_path__ + "static/media/noprofilepic.5fa8af8617670bf158469b1998680121.png";